const COMMON = {
  PROFILE: {
    SETTINGS: {
      TITLE: "Settings",

      TELEGRAM_BOT: "Telegram bot",
      TELEGRAM_DES: "You can enable or disable your Telegram bot from here.",
      ENABLED: "Enabled",
      DISABLED: "Disbaled",
      PEND_FOR_CONFIRM: "awaiting confirmation",
      ENABLE: "Enable",
      DISABLE: "Disbale",
      CONFIRM_ACTIVATION: "confirm activation",

      LANG: "Language",
      LANG_DES: "You can change the language of panel from here",
      LANG_SELECT_DEFAULT_OP: "Choose a language",
      FA_LANG: "Persian",
      EN_LANG: "English",

      NAME: "Name",
      NAME_DES: "The name displayed to visitor in the widget",
      NAME_PH: "Enter your name.",

      AGENT_TITLE: "Title",
      AGENT_TITLE_DES:
        "If the title is entered, the operator's name will be displayed to the user in the conversation widget section",
      AGENT_TITLE_PH: "Enter your title.",

      EMAIL: "Email",
      EMAIL_DES:
        "This email is used to enter the main management section and the web application, and notifications are also sent to this email.",
      EMAIL_PH: "Enter your email.",

      PASSWORD: "Password",
      PASSWORD_DES:
        "The password must be at least 6 characters and use numbers, small and capital letters, and no spaces.",
      PASSWORD_PH: "Enter your password.",

      AVATAR: "Avatar",
      AVATAR_DES:
        "Your avatar that will be displayed to users you are chatting with.",
      BROWSE_IMAGE: "Choose Image",
      DELETE_IMAGE: "Delete Image",
      AVATAR_UPLOAD_HINT: "The maximum image size is 500 KB",

      THEME: "Theme",
      THEME_DES:
        "Personalize your web app theme. Only you will see the changes.",
      DARK_MODE: "Dark",
      LIGHT_MODE: "Light",

      ACCOUNT_SETTINGS: "Account Settings",

      COMING_SOON: "Coming Soon",
      EXIT: "Logout",
      SUBMIT: "Save Changes",
    },
    ALARMS: {
      TITLE: "Alarms",

      ALARM_ACTIVATION: "Enable alarm sounds",
      ALARM_ACTIVATION_DES:
        "By activating this option, alerts will be activated for you.",
      NEW_MSG_SOUND: "New Message Sound",
      NEW_VISTOR_SOUND: "New Visitor Sound",
      NEW_MSG_IN_CONV_SOUND: "New Message Sound During Conversation",
    },
    ACTIVATE_BROWSER_NOTIF: "Activate browser notif",
    EXIT: "Logout",
    CLOSE: "Close",
    SUBMIT: "Save Changes",
  },
  MODAL: {
    EXIT_CONFIRM: "Are you sure you want to logout ?",
    DELETE_PENDINGS_CONFIRM: "Do you want to delete all conversations ?",
    DELETE_ONGOINGS_CONFIRM: "Do you want to close all conversations ?",
    ADD_TO_BLACK_LIST_TITLE: "Add to Blacklist",
    ADD_TO_BLACK_LIST_FOR: "Add to the Blacklist for:",
    BAN_FOR_ONE_DAY: "One day",
    BAN_FOR_ONE_WEEK: "One week",
    BAN_FOR_ONE_MONTH: "One month",
    BAN_FOR_ONE_ALWAYS: "Always",
    CLOSE_CONV_CONFIRM: "Do you want to close this conversation ?",
    REJECT_CONV_CONFIRM: "Do you want to reject this conversation ?",
    LOGOUT_CONFIRMATION: "Are you sure you want to exit ?",
    DELETE_SHORTCUT_MSG_CONFIRM:
      "Are you sure you want to delete this message ?",
    PACKAGE_EXPIRE:
      "Your package has expired ! Please inform your admin so that they can upgrade or renew the package.",
    TRANSFER_CONV_TITLE: "Transferring Conversation",
    TRANSFER_CONV_CONFIRM:
      "Are you sure you want to transfer this conversation ?",
    BUY_AND_RENEWAL: "Buy/renewal",
    CANCEL: "Cancel",
    CONFIRM: "Confirm",
    CLOSE: "Close",
  },
  FORM_ERRORS: {
    FIELD_REQUIRED: "This field cannot be empty",
    INVALID_EMAIL: "Email format is not valid",
    INVALID_PASSWORD: "Password is not valid",
  },

  FILE_PREVIEW: {
    NOT_SUPPORTING_MSG: "File is not supported",
    CLOSE: "Close",
    CANCEL: "Cancel",
    ARE_YOU_SURE: "Are you sure you want to send this file?",
    CONFIRM: "Confirm",
  },

  SPECIAL_MSG_TYPES: {
    IMAGE: "Image",
    AUDIO: "Audio message",
    FILE: "File",
  },

  BROWSER_NOT_SUPPOR_VIDEO_FILES: "Your browser does not support video file",

  BTN_DISABLED_PURCHASE_LINK_TITLE: "Purchase",
  BTN_DISABLED_TOOLTIP_TEXT:
    "To use this feature you need to purchase #package# package. ",

  PACKAGES: {
    PREMIUM: "Premium",
    COMMERCIAL: "Commercial",
    BASIC: "Basic",
  },

  POPUP_MESSAGE: {
    CLOSE_DEFAULT: "Close",
    NEVER_SHOW_DEFAULT: "don't show this message again",
  },

  SECONDS: "#second# seconds",
  MINUTES: "#minute# minutes",
  HOURS: "#hour# hours",
  TO_USE_YOU_SHOULD_UPGRADE:
    "Please consider upgrading your plan to use this feature.",
  UPGRADE_LINK: "Upgrade Link",

  ACTIVATE: "Activate",
  RENEW: "renew",

  DO_NOT_SHOW_MSG_AGAIN: "Do not show this message again",

  CONFIRM_ACTIVATION: "Package upgrade",
};

export default COMMON;
